// extracted by mini-css-extract-plugin
module.exports = {"container":"ChipList_container__2TfYN","chip":"ChipList_chip__ef32w","active":"ChipList_active__2zufX"};